import { type Styles } from '@adornis/ass/style.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { XButton } from '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-link.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { state } from 'lit/decorators/state.js';

@customElement('ils-progress-button')
export class ILSProgressButton extends XButton {
  override styles() {
    return [
      ...(super.styles() as Styles[]),
      {
        ':host([mode=action])': {
          position: 'relative',
          background: 'none',
          color: this.colors.accent,
        },
        '#innerwrapper': {
          zIndex: '1',
        },
        '#progress': {
          zIndex: '0',
          position: 'absolute',
          top: '0',
          left: '0',
          height: '100%',
          width: '100px',
          background: this.colors.accent.shade(100),
          transformOrigin: 'left',
        },
      },
    ];
  }

  @state() public currentTime = 1;
  @state() public progress = 0;
  @state() size = new WindowSizeController(this);

  override render() {
    return html`
      ${super.render()}
      <div
        id="progress"
        ${css({
          transition: `transform 1s linear 0s`,
          transform: `scaleX(${(Math.min((this.progress || 0) * this.size.width!, this.size.width!) / 100).toFixed(
            2,
          )})`,
        })}
      ></div>
    `;
  }
}
